/* DWL international digital push — 2026-09-25
   1) Non-U.S. detection: Liquid localization country first (data-dwl-country on <html>), then
      /browsing_context_suggestions.json (Shopify geo suggestion). QA override: ?dwl_geo=CA (session-scoped).
   2) Reveals [data-dwl-intl] panels for non-U.S. visitors; U.S. visitors see no change.
   3) Cart swap: removes every paperback line, adds the chosen digital item, then opens /cart.
   4) Top bar rotation between the two announcement messages. */
(function () {
  var US = 'US';
  var root = document.documentElement;

  function reveal() {
    if (!document.body || !document.body.classList.contains('dwl-intl')) return;
    var els = document.querySelectorAll('[data-dwl-intl][hidden]');
    for (var i = 0; i < els.length; i++) els[i].removeAttribute('hidden');
  }
  function setIntl(code) {
    try { sessionStorage.setItem('dwl_geo', code); } catch (e) {}
    document.body.classList.add('dwl-intl');
    reveal();
    if (window.MutationObserver) {
      new MutationObserver(function () { reveal(); }).observe(document.body, { childList: true, subtree: true });
    }
  }
  function detect() {
    var forced = null;
    try {
      var q = new URLSearchParams(location.search).get('dwl_geo');
      if (q) { forced = q.toUpperCase(); sessionStorage.setItem('dwl_geo', forced); }
      var cached = forced || sessionStorage.getItem('dwl_geo');
      if (cached) { if (cached !== US) setIntl(cached); return; }
    } catch (e) {}
    var liquidCountry = (root.getAttribute('data-dwl-country') || '').toUpperCase();
    if (liquidCountry && liquidCountry !== US) { setIntl(liquidCountry); return; }
    if (!window.fetch) return;
    fetch('/browsing_context_suggestions.json?source=geolocation_recommendation&country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!c) return;
        c = String(c).toUpperCase();
        if (c !== US) setIntl(c); else { try { sessionStorage.setItem('dwl_geo', US); } catch (e) {} }
      })
      .catch(function () {});
  }

  function postJSON(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-dwl-swap]') : null;
    if (!btn) return;
    ev.preventDefault();
    var box = btn.closest('[data-dwl-cart]');
    if (!box || btn.disabled) return;
    var keys = (box.getAttribute('data-keys') || '').split(',').filter(Boolean);
    var vid = btn.getAttribute('data-dwl-swap') === 'bundle' ? box.getAttribute('data-bundle') : box.getAttribute('data-ebook');
    var buttons = box.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) buttons[i].disabled = true;
    btn.textContent = 'Updating your cart';
    var p = Promise.resolve();
    keys.forEach(function (k) { p = p.then(function () { return postJSON('/cart/change.js', { id: k, quantity: 0 }); }); });
    p.then(function () { return postJSON('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] }); })
      .then(function () { location.href = '/cart'; })
      .catch(function () { location.href = '/cart'; });
  });

  function rotateTopbar() {
    var bar = document.getElementById('wallach-topbar');
    if (!bar) return;
    var slides = bar.querySelectorAll('.dwl-tb');
    if (slides.length < 2) return;
    var every = parseInt(bar.getAttribute('data-dwl-rotate'), 10) || 6000;
    var idx = 0;
    setInterval(function () {
      slides[idx].classList.remove('is-on');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-on');
    }, every);
  }

  function init() { detect(); rotateTopbar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
